import * as React from 'react';
import PropTypes from 'prop-types';
var SvgBadgesMulticolorSummitSmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M.844.999C.584.561.894 0 1.394 0h14.721a.32.32 0 01.275.159l7.021 11.842-7.021 11.842a.324.324 0 01-.275.159H1.395c-.502 0-.81-.561-.551-1L7.365 12 .844.999z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC4C02",
    d: "M21.772 12l-6.17-10.179a.67.67 0 00-.57-.321H3.272c-.26 0-.42.284-.285.507L9.044 12h12.728z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF4017",
    d: "M2.987 21.994L9.044 12h12.728l-6.17 10.179a.67.67 0 01-.57.32H3.272a.334.334 0 01-.285-.506"
  })));
});
SvgBadgesMulticolorSummitSmall.defaultProps = {
  height: 24,
  width: 24
};
SvgBadgesMulticolorSummitSmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgBadgesMulticolorSummitSmall;